import React from 'react';
import { BffBonusData } from '@lucky7ventures/bff-types';
import { BonusModalBase } from '@/features/modal/modals/BonusModalBase';

const AvailableBonusesModal = ({
  closeModal,
  bonuses,
}: {
  closeModal: VoidFunction;
  bonuses: BffBonusData[];
}) => (
  <BonusModalBase
    closeModal={closeModal}
    bonuses={bonuses}
    titleId="availableBonusesModal.title"
    subtitleId="availableBonusesModal.subtitle"
  />
);

export default AvailableBonusesModal;
